import { useQuery } from 'react-query';
import { CurrenciesService } from '../../services';
import { ICurrency } from '../../interfaces';

export const useCurrencies = () => {
  return useQuery<ICurrency[], Error>(
    ['currencies', 'all'],
    async () => {
      const result = await CurrenciesService.getList({ per_page: 1000 });
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 10 * 60 * 1000 },
  );
};
